export const keypointsStyles = {
  wrapper: {
    display: { laptop: "flex" },
    alignItems: { laptop: "center" },
    justifyContent: { laptop: "center" },
    mx: {
      mobile: "1.5rem",
      tablet: "auto",
      laptop: "unset",
    },
    px: {
      tablet: "2.438rem",
      laptop: "unset",
    },
    maxWidth: {
      tablet: "48rem",
      laptop: "unset",
    },
    mb: {
      tablet: "4.188rem",
      laptop: "10rem",
    },
  },
};
